// extracted by mini-css-extract-plugin
module.exports = {"power-backup-C":"C_power-backup-C__h2kQl"};